import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=29c5ba90"
import script from "./ProductNew.vue?vue&type=script&lang=js"
export * from "./ProductNew.vue?vue&type=script&lang=js"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=29c5ba90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports